/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Assets } from './Assets';
import {
    AssetsFromJSON,
    AssetsFromJSONTyped,
    AssetsToJSON,
} from './Assets';
import type { ControlAbridgedCyberBenchmark } from './ControlAbridgedCyberBenchmark';
import {
    ControlAbridgedCyberBenchmarkFromJSON,
    ControlAbridgedCyberBenchmarkFromJSONTyped,
    ControlAbridgedCyberBenchmarkToJSON,
} from './ControlAbridgedCyberBenchmark';
import type { ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount } from './ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount';
import {
    ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSON,
    ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSONTyped,
    ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountToJSON,
} from './ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount';
import type { ControlEntityMetrics } from './ControlEntityMetrics';
import {
    ControlEntityMetricsFromJSON,
    ControlEntityMetricsFromJSONTyped,
    ControlEntityMetricsToJSON,
} from './ControlEntityMetrics';
import type { ControlEntityRelation } from './ControlEntityRelation';
import {
    ControlEntityRelationFromJSON,
    ControlEntityRelationFromJSONTyped,
    ControlEntityRelationToJSON,
} from './ControlEntityRelation';
import type { ControlEntityRiskScoreV2 } from './ControlEntityRiskScoreV2';
import {
    ControlEntityRiskScoreV2FromJSON,
    ControlEntityRiskScoreV2FromJSONTyped,
    ControlEntityRiskScoreV2ToJSON,
} from './ControlEntityRiskScoreV2';
import type { ControlPolicy } from './ControlPolicy';
import {
    ControlPolicyFromJSON,
    ControlPolicyFromJSONTyped,
    ControlPolicyToJSON,
} from './ControlPolicy';
import type { ControlTrial } from './ControlTrial';
import {
    ControlTrialFromJSON,
    ControlTrialFromJSONTyped,
    ControlTrialToJSON,
} from './ControlTrial';

/**
 * 
 * @export
 * @interface ControlAdminSearchResponseEntity
 */
export interface ControlAdminSearchResponseEntity {
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    entity_logo_url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAdminSearchResponseEntity
     */
    domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAdminSearchResponseEntity
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    monit_type?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAdminSearchResponseEntity
     */
    data_sources?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAdminSearchResponseEntity
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {ControlEntityMetrics}
     * @memberof ControlAdminSearchResponseEntity
     */
    metrics?: ControlEntityMetrics;
    /**
     * 
     * @type {Assets}
     * @memberof ControlAdminSearchResponseEntity
     */
    assets?: Assets;
    /**
     * 
     * @type {ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount}
     * @memberof ControlAdminSearchResponseEntity
     */
    vulnerabilities?: ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount;
    /**
     * 
     * @type {number}
     * @memberof ControlAdminSearchResponseEntity
     */
    dataleaks?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAdminSearchResponseEntity
     */
    lookalikes?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAdminSearchResponseEntity
     */
    honeypots?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAdminSearchResponseEntity
     */
    torrents?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAdminSearchResponseEntity
     */
    risk_score?: number;
    /**
     * 
     * @type {ControlEntityRiskScoreV2}
     * @memberof ControlAdminSearchResponseEntity
     */
    risk_score_v2?: ControlEntityRiskScoreV2;
    /**
     * 
     * @type {ControlEntityRiskScoreV2}
     * @memberof ControlAdminSearchResponseEntity
     */
    previous_risk_score_v2?: ControlEntityRiskScoreV2;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    report_url?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ControlAdminSearchResponseEntity
     */
    localized_reports?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    scanned?: string;
    /**
     * 
     * @type {ControlAbridgedCyberBenchmark}
     * @memberof ControlAdminSearchResponseEntity
     */
    cyber_benchmark?: ControlAbridgedCyberBenchmark;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    external_id?: string;
    /**
     * 
     * @type {ControlPolicy}
     * @memberof ControlAdminSearchResponseEntity
     */
    policy?: ControlPolicy;
    /**
     * 
     * @type {ControlEntityRelation}
     * @memberof ControlAdminSearchResponseEntity
     */
    relation?: ControlEntityRelation;
    /**
     * 
     * @type {ControlTrial}
     * @memberof ControlAdminSearchResponseEntity
     */
    trial?: ControlTrial;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminSearchResponseEntity
     */
    crole_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAdminSearchResponseEntity
     */
    main?: boolean;
}

/**
 * Check if a given object implements the ControlAdminSearchResponseEntity interface.
 */
export function instanceOfControlAdminSearchResponseEntity(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlAdminSearchResponseEntityFromJSON(json: any): ControlAdminSearchResponseEntity {
    return ControlAdminSearchResponseEntityFromJSONTyped(json, false);
}

export function ControlAdminSearchResponseEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAdminSearchResponseEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_logo_url': !exists(json, 'entity_logo_url') ? undefined : json['entity_logo_url'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'monit_type': !exists(json, 'monit_type') ? undefined : json['monit_type'],
        'data_sources': !exists(json, 'data_sources') ? undefined : json['data_sources'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'metrics': !exists(json, 'metrics') ? undefined : ControlEntityMetricsFromJSON(json['metrics']),
        'assets': !exists(json, 'assets') ? undefined : AssetsFromJSON(json['assets']),
        'vulnerabilities': !exists(json, 'vulnerabilities') ? undefined : ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSON(json['vulnerabilities']),
        'dataleaks': !exists(json, 'dataleaks') ? undefined : json['dataleaks'],
        'lookalikes': !exists(json, 'lookalikes') ? undefined : json['lookalikes'],
        'honeypots': !exists(json, 'honeypots') ? undefined : json['honeypots'],
        'torrents': !exists(json, 'torrents') ? undefined : json['torrents'],
        'risk_score': !exists(json, 'risk_score') ? undefined : json['risk_score'],
        'risk_score_v2': !exists(json, 'risk_score_v2') ? undefined : ControlEntityRiskScoreV2FromJSON(json['risk_score_v2']),
        'previous_risk_score_v2': !exists(json, 'previous_risk_score_v2') ? undefined : ControlEntityRiskScoreV2FromJSON(json['previous_risk_score_v2']),
        'report_url': !exists(json, 'report_url') ? undefined : json['report_url'],
        'localized_reports': !exists(json, 'localized_reports') ? undefined : json['localized_reports'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'scanned': !exists(json, 'scanned') ? undefined : json['scanned'],
        'cyber_benchmark': !exists(json, 'cyber_benchmark') ? undefined : ControlAbridgedCyberBenchmarkFromJSON(json['cyber_benchmark']),
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'policy': !exists(json, 'policy') ? undefined : ControlPolicyFromJSON(json['policy']),
        'relation': !exists(json, 'relation') ? undefined : ControlEntityRelationFromJSON(json['relation']),
        'trial': !exists(json, 'trial') ? undefined : ControlTrialFromJSON(json['trial']),
        'crole_id': !exists(json, 'crole_id') ? undefined : json['crole_id'],
        'main': !exists(json, 'main') ? undefined : json['main'],
    };
}

export function ControlAdminSearchResponseEntityToJSON(value?: ControlAdminSearchResponseEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'entity_logo_url': value.entity_logo_url,
        'domains': value.domains,
        'ip_addresses': value.ip_addresses,
        'monit_type': value.monit_type,
        'data_sources': value.data_sources,
        'keywords': value.keywords,
        'metrics': ControlEntityMetricsToJSON(value.metrics),
        'assets': AssetsToJSON(value.assets),
        'vulnerabilities': ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountToJSON(value.vulnerabilities),
        'dataleaks': value.dataleaks,
        'lookalikes': value.lookalikes,
        'honeypots': value.honeypots,
        'torrents': value.torrents,
        'risk_score': value.risk_score,
        'risk_score_v2': ControlEntityRiskScoreV2ToJSON(value.risk_score_v2),
        'previous_risk_score_v2': ControlEntityRiskScoreV2ToJSON(value.previous_risk_score_v2),
        'report_url': value.report_url,
        'localized_reports': value.localized_reports,
        'status': value.status,
        'created': value.created,
        'updated': value.updated,
        'scanned': value.scanned,
        'cyber_benchmark': ControlAbridgedCyberBenchmarkToJSON(value.cyber_benchmark),
        'external_id': value.external_id,
        'policy': ControlPolicyToJSON(value.policy),
        'relation': ControlEntityRelationToJSON(value.relation),
        'trial': ControlTrialToJSON(value.trial),
        'crole_id': value.crole_id,
        'main': value.main,
    };
}

